import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type NotificationsState = {
  /** Unix seconds of the last time the user opened the notification panel. */
  lastSeenAt: number;
  markAllSeen: () => void;
};

/**
 * Client-side notification "seen" tracker.
 *
 * The backend's `/api/v1/ui-config/notification` response has no read/unread
 * field per user, so we approximate the dot semantics locally: every
 * notification whose `created_at` (unix seconds) is greater than this
 * `lastSeenAt` counts as unread. Tapping the bell on the home header
 * advances `lastSeenAt` to "now", clearing the dot until the next batch
 * arrives.
 *
 * Persisted to localStorage so the user doesn't see the same dot again
 * after refresh; cross-device sync would need a backend flag.
 */
export const useNotificationsStore = create<NotificationsState>()(
  persist(
    (set) => ({
      lastSeenAt: 0,
      markAllSeen: () => set({ lastSeenAt: Math.floor(Date.now() / 1000) }),
    }),
    { name: 'hg.notifications' },
  ),
);
